import type { ColorPalette } from '@percent/domain/giving'
import { hexToRgbTriplet } from './hexToRgbTriplet'

export type CssVariablesColorPalette = {
  [key in keyof ColorPalette as `--${key}`]: ColorPalette[key]
}

export const colorPaletteToCssVariables = (colorPalette: ColorPalette): CssVariablesColorPalette =>
  Object.entries(colorPalette).reduce<Record<string, string>>((acc, [key, value]) => {
    acc[`--${key}`] = hexToRgbTriplet(value)

    return acc
  }, {}) as CssVariablesColorPalette
